import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../app-constants';
import { User } from '../model/User';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  apiURL: string = environment.apiBaseUrl + 'user';

  constructor(private http: HttpClient, private router: Router, public dataService: DataService) { }

  recuperar(login: any) {
    let user = new User();
    user.login = login;

    return this.http.post(AppConstants.getBaseUrlPath + 'recuperar/', user).subscribe(data => {
      alert(JSON.parse(JSON.stringify(data)).error);
    },
      error => {
        console.error("Erro ao recuperar login");
        alert('Erro ao recuperar login!')
      }
    );
  }


  login(usuario: any) {
    return this.http.post(AppConstants.baseLogin, JSON.stringify(usuario)).subscribe(data => {
      /*Retorno Http*/
      var token = JSON.parse(JSON.stringify(data)).Authorization.split(' ')[1];
      localStorage.setItem("token", token);
      this.buscarUsuarioLogado();
      this.buscarPermissaoUsuario();
      this.router.navigate(['home']);
    },
      error => {
        console.error(error);
        alert('Acesso Negado!')
      }
    );
  }

  buscarUsuarioLogado() {
    this.http.get<any>(`${this.apiURL}/usuarioLogado`).subscribe(data => {
      var usuarioLogado = JSON.parse(JSON.stringify(data))
      localStorage.setItem("usuarioLogado", usuarioLogado.name);
      localStorage.setItem("horaExpirarToken", usuarioLogado.horaExpirarToken);
      this.dataService.usuarioLogado = usuarioLogado.name;
      this.dataService.horaExpirarToken = usuarioLogado.horaExpirarToken;
      this.dataService.logado = true;
    },
      error => {
      }
    );
  }

  buscarPermissaoUsuario() {
    this.http.get<string[]>(`${this.apiURL}/buscarPermissaoUsuario`)
      .subscribe(permissoes => {
        this.dataService.setPermissoes(permissoes);
      });
  }

}